module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/babel-runtime/regenerator/index.js
// module id = 1218
// module chunks = 1